/**
 * THE ADDRESS RESOURCES LIVES AT.
 *
 * The same two-file shape as field onboarding: a screen that owns the page
 * furniture, and a module that owns the work. It is worth keeping separate
 * because the module is the half with a database behind it, and a test that
 * wants to drive the shelf should not have to render a header and a sign-out
 * button to get at it.
 *
 * `staff` GOES DOWN TOO, and not for decoration: a document read in the Portal
 * is watermarked with the name and address of the person reading it. A
 * screenshot cannot be prevented on the web, so the control is attribution --
 * see the header of MarkdownDoc.jsx.
 *
 * PERMISSIONS ARRIVE AS A PROP WHEN THE SHELL HAS THEM, and are fetched here
 * when they do not — the shell asks once for the rail and hands them down.
 * They decide one thing on this screen and one thing only: whether the publish
 * panel is offered. Nobody needs a permission to READ a resource, which is the
 * whole reason this is not a card.
 */

import { useEffect, useState } from 'react';
import { O, SANS, LoadingPanel } from '../ui';
import { fetchMyPermissions } from '../lib/portal';
import { Page, PortalHeader } from '../Portal';
import PortalResources from './PortalResources';

export default function ResourcesScreen({ staff, onSignOut, cards = [], permissions = null }) {
  const [own, setOwn] = useState(permissions);

  useEffect(() => {
    if (permissions !== null) { setOwn(permissions); return undefined; }
    let alive = true;
    fetchMyPermissions().then(({ data }) => { if (alive) setOwn(data || []); });
    return () => { alive = false; };
  }, [permissions]);

  return (
    <Page wide>
      <PortalHeader staff={staff} onSignOut={onSignOut} />
      <section aria-labelledby="resources-heading">
        <h1
          id="resources-heading"
          style={{ fontFamily: SANS, fontSize: 17, fontWeight: 700, color: O.ink, margin: '0 0 6px' }}
        >
          Resources
        </h1>
        {own === null
          ? <LoadingPanel message="Opening Resources…" />
          : <PortalResources cards={cards} permissions={own} staff={staff} />}
      </section>
    </Page>
  );
}
